module.exports = __webpack_public_path__ + "static/media/icon_29.01c5dfe6.svg";